import axios from 'axios';

export default class Api {
    constructor() {
        this.API_ROOT = '/api';
    }

    getFullUrl(fragment) {
        return this.API_ROOT + fragment;
    }

    get(url, params) {
        return axios.get(this.getFullUrl(url), {
            params,
        }).catch((error) => {
            return error;
        });
    }

    post(url, params) {
        return axios.post(this.getFullUrl(url), params)
            .catch((error) => {
                return error;
            });
    }

    patch(url, params) {
        return axios.patch(this.getFullUrl(url), params)
            .catch((error) => {
                return error;
            });
    }
}
